// extracted by mini-css-extract-plugin
export default {"team":"about_team__HNGLB","about_image":"about_about_image__1pOtS","quote":"about_quote__CNW6K","banner":"about_banner__JEUSC"};